"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionPanelSummary = exports.ExpansionPanelSummaryContent = exports.ExpansionPanelSummaryHeading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ExpansionPanelContext_1 = require("./ExpansionPanelContext");
const elements_1 = require("../../elements");
const react_spring_1 = require("react-spring");
const ExpansionPanelSummaryHeading = ({ children }) => (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "expansion-panel__summary-heading" }, { children: children }), void 0);
exports.ExpansionPanelSummaryHeading = ExpansionPanelSummaryHeading;
const ExpansionPanelSummaryContent = ({ children }) => (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "expansion-panel__summary-content" }, { children: children }), void 0);
exports.ExpansionPanelSummaryContent = ExpansionPanelSummaryContent;
const ExpansionPanelSummary = ({ children }) => {
    const { setOpen, open } = (0, react_1.useContext)(ExpansionPanelContext_1.ExpansionPanelContext);
    const [style, set] = (0, react_spring_1.useSpring)(() => ({ rotateZ: 0 }));
    (0, react_1.useEffect)(() => {
        if (open) {
            set({ rotateZ: 90 });
        }
        else {
            set({ rotateZ: 0 });
        }
    }, [open]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "expansion-panel__summary", onClick: () => setOpen(!open) }, { children: [children, (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "expansion-panel__indicator" }, { children: (0, jsx_runtime_1.jsx)(react_spring_1.animated.div, Object.assign({ style: {
                        transform: style.rotateZ.interpolate(z => `rotateZ(${z}deg)`)
                    } }, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "chevronRight" }, void 0) }), void 0) }), void 0)] }), void 0));
};
exports.ExpansionPanelSummary = ExpansionPanelSummary;
//# sourceMappingURL=ExpansionPanelSummary.js.map